import { supabase } from "@/integrations/supabase/client";

const BUCKET = "media";
const YEAR_SECONDS = 60 * 60 * 24 * 365;

/**
 * Uploads an image into the current user's folder and returns a long-lived
 * signed URL that can be stored on the record and rendered anywhere.
 */
export async function uploadImage(file: File, userId: string, kind: string) {
  if (!file.type.startsWith("image/")) throw new Error("Please choose an image file.");
  if (file.size > 5 * 1024 * 1024) throw new Error("Images must be under 5 MB.");

  const ext = (file.name.split(".").pop() ?? "png").toLowerCase().slice(0, 5);
  const path = `${userId}/${kind}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;

  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, { cacheControl: "31536000", upsert: false });
  if (error) throw error;

  const { data, error: signError } = await supabase.storage
    .from(BUCKET)
    .createSignedUrl(path, YEAR_SECONDS);
  if (signError) throw signError;
  return data.signedUrl;
}
